import { useState, useEffect } from 'react';
import withLazyLoad from 'bv-lazy-load';
import { getCookie, removeCookie } from 'bv';

const SelfExclusionSuccessModal = withLazyLoad()('selfExclusionSuccessModal');

const SelfExclusionSuccessModalComponent = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (getCookie('user_self_excluded')) {
      setShowModal(true);
      removeCookie('user_self_excluded');
    }
  }, []);

  return showModal ? <SelfExclusionSuccessModal /> : null;
};

export default SelfExclusionSuccessModalComponent;
